function readJsonStorage(key: string): Record<string, any> {
  if (typeof window === 'undefined') return {};

  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function normalizeScopePart(value: unknown): string {
  if (value === null || value === undefined) return '';
  const text = String(value).trim();
  if (!text || /^(undefined|null)$/i.test(text)) return '';
  return text;
}

export function getCurrentOrgScope(): string {
  if (typeof window === 'undefined') return 'server';

  const branchId = normalizeScopePart(window.localStorage.getItem('login_branch_id'));
  const loginCompany = readJsonStorage('loginCompany');
  const companyId =
    normalizeScopePart(loginCompany?.company?.id) ||
    normalizeScopePart(loginCompany?.company_id) ||
    normalizeScopePart(loginCompany?.id);
  const companyKey =
    normalizeScopePart(loginCompany?.company?.company_key) ||
    normalizeScopePart(loginCompany?.company_key) ||
    normalizeScopePart(loginCompany?.company_branch?.company_branch_key);

  if (branchId) return `branch:${branchId}`;
  if (companyId) return `company:${companyId}`;
  if (companyKey) return `company-key:${companyKey}`;

  return 'unknown-org';
}